// type accessObject = { parent: string; child: string | accessObject };

const isPrimitive = (value) => {
  switch (typeof value) {
    case "object":
    case "function":
      return false;
    default:
      return true;
  }
};

const hasChanged = (obj1, obj2) => {
  if (Object.keys(obj1).length !== Object.keys(obj2).length) return true;

  for (const key of Object.keys(obj1)) {
    if (!Array.isArray(obj1[key]) && isPrimitive(obj1[key]) && obj1[key] !== obj2[key]) return true;
    if (isPrimitive(obj1[key]) && isPrimitive(obj2[key])) continue;

    if (!obj2[key] || typeof obj1[key] !== typeof obj2[key]) return true;

    if ((Array.isArray(obj1[key]) || !isPrimitive(obj1[key])) && hasChanged(obj1[key], obj2[key])) return true;
  }
  return false;
};

const getChangedKey = (obj1, obj2) => {
  for (const key of Object.keys(obj1)) {
    if (!Array.isArray(obj1[key]) && isPrimitive(obj1[key]) && obj1[key] !== obj2[key]) return key;
    if (isPrimitive(obj1[key]) && isPrimitive(obj2[key])) continue;

    if (!obj2[key] || typeof obj1[key] !== typeof obj2[key]) return key;

    if (Array.isArray(obj1[key]) || !isPrimitive(obj1[key])) {
      const child = getChangedKey(obj1[key], obj2[key]);
      if (child) return { parent: key, child: child };
    }
  }

  return null;
};

const getAllChangedKeys = (obj1, obj2, res = []) => {
  for (const key of Object.keys(obj1)) {
    if (!Array.isArray(obj1[key]) && isPrimitive(obj1[key]) && obj1[key] !== obj2[key]) res.push(key);

    if (isPrimitive(obj1[key]) && isPrimitive(obj2[key])) continue;

    if (!obj2[key] || typeof obj1[key] !== typeof obj2[key]) res.push(key);

    if (Array.isArray(obj1[key]) || !isPrimitive(obj1[key])) {
      const children = getAllChangedKeys(obj1[key], obj2[key]);
      if (!children) continue;

      for (const child of children) {
        res.push({ parent: key, child: child });
      }
    }
  }

  return res;
};

const getAccessStringFromKey = (obj, res = []) => {
  if (obj === null) return [];

  res.push(obj.parent);
  if (typeof obj.child === "object") res.push(...getAccessStringFromKey(obj.child));
  else res.push(obj.child);

  return res;
};

const getValueFromAccessString = (obj, path) => {
  if (path.length === 0) return null;

  let current = structuredClone(obj);
  for (const subPath of path) {
    current = current[subPath];
  }
  return current;
};

/**
 * Creates nested properties in an object
 * This is a "soft" implementation, meaning that it will not overwrite existing properties
 *
 * @param {Object} obj - The object to which the properties will be added
 * @param {Array} properties - The list of properties to be added
 * @returns The object with the new properties
 */
const addMultiLevelProperty = function (obj, properties) {
  if (!properties || properties.length === 0) return obj;

  const property = properties[0];
  obj[property] = addMultiLevelProperty(obj[property] || {}, properties.slice(1));

  return obj;
};

export { hasChanged, getChangedKey, getAllChangedKeys, getAccessStringFromKey, getValueFromAccessString, addMultiLevelProperty };
